import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { projectWorkspaceSearchSchema } from '../../../../features/projects/search'

/** The project workspace; its tab, plan view and node drawer live in the URL. */
export const Route = createFileRoute('/_app/projects/$projectId')({
  staticData: { crumb: 'project' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'projects.read'),
  validateSearch: projectWorkspaceSearchSchema,
  component: Outlet,
})
